import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Modal from 'react-modal';

import StayTuned from '../Assets/PromoFlyers/StayTuned_Final.png';
import Feb2PROMO from '../Assets/PromoFlyers/Feb2PROMO.png';
import DuckInnApril from '../Assets/PromoFlyers/DuckInn_04052024.png';
import aprilPromo from '../Assets/PromoFlyers/420Promo.png';
import Hogs4Hope from '../Assets/PromoFlyers/Hogs4Hope.png';
import Gleasons from '../Assets/PromoFlyers/GleasonsPromo.png';
import JoeysJune from '../Assets/PromoFlyers/Joeys_06082024.png';
import DuckJune from '../Assets/PromoFlyers/Duck_06212024 copy.png';
import GleasonsJune from '../Assets/PromoFlyers/Gleasons_06292024.png';
import LaCasaJuly from '../Assets/PromoFlyers/LaCasa_Promo copy Large.png';
import RamblingJuly from '../Assets/PromoFlyers/Rambling_07.27.2024.png';
import GleasonsHalloween from '../Assets/PromoFlyers/Gleasons_Halloween.png';
import WestchesterTattooCon from '../Assets/PromoFlyers/WestchesterTattooCon Large.png';
import Lucys2024 from '../Assets/PromoFlyers/Lucys_11.2024.png';
import Stockroom02_2025 from '../Assets/PromoFlyers/Stockroom_02.2025.png'
import Eminescence from '../Assets/PromoFlyers/Eminescence_Flyer.png'
import Schism_052025 from '../Assets/PromoFlyers/89North_flyer.png'
import Saxon07122025 from '../Assets/PromoFlyers/07.12.2025_Flyer.png'
import BlinkYonkers from '../Assets/PromoFlyers/Blink_Yonkers.png'
import RedlineOct from '../Assets/PromoFlyers/RedlinePromo.png'
import Schism_012026 from '../Assets/PromoFlyers/89North_01092026.jpeg'
import SayItAintSoYO from '../Assets/PromoFlyers/YOnkersSayItAintSo.png'
import SmashingFundraiser from '../Assets/PromoFlyers/SmashingPumpkins_PromoFlyer.png'
import HellaDoubt062026 from '../Assets/PromoFlyers/HellaDoubt_PromoFlyer_06.2026FINAL2.png'
import GarciasFB from '../Assets/PromoFlyers/GARCIAS_20260828_witb_facebook_1920x1005-.png'
import GarciasIG from '../Assets/PromoFlyers/Garcias_20260828_witb_igPromo_1080x1350.png'
import WCCFlyer from '../Assets/PromoFlyers/WCCFlyer_draft2_shorter_UPDATED.png'


Modal.setAppElement('#root');

const Events = () => {
  const [value, setValue] = useState(new Date());
  const [modalIsOpen, setIsOpen] = useState(false);

  const onChange = (newValue) => {
    setValue(newValue);
  };

  const events = [
    { date: new Date('2024-02-02T20:00:00'), title: 'Live at Joey\'s Bar', image: Feb2PROMO },
    { date: new Date('2024-04-20T18:00:00'), title: '420 Fest', image: aprilPromo },
    { date: new Date('2024-07-26T21:00:00'), title: 'La Casa in Mamaroneck', image: LaCasaJuly },
    { date: new Date('2024-07-27T20:00:00'), title: 'Rambling House in The Bronx', image: RamblingJuly },
    { date: new Date('2024-10-25T20:00:00'), title: 'Halloween Show @ Gleasons', image: GleasonsHalloween },
    { date: new Date('2024-11-08T21:00:00'), title: 'The Garage at Lucys in Pleasantville', image: Lucys2024 },
    { date: new Date('2024-11-16T22:00:00'), title: 'NY Tattoo & Horror Con @Westchester County Center', image: WestchesterTattooCon },
    { date: new Date('2025-02-15T19:30:00'), title: 'Stockroom Showcase at Yonkers Brewery', image: Stockroom02_2025 },
    { date: new Date('2025-04-26T20:00:00'), title: 'Yonkers Brewery w/Evanescence Tribute', image: Eminescence },
    { date: new Date('2025-05-02T19:00:00'), title: '89 North w/SCHISM A Tribute To TOOL', image: Schism_052025 },
    { date: new Date('2025-05-31T20:00:00'), title: 'Yonkers Brewery w/Blink 182 Tribute', image: BlinkYonkers },
    { date: new Date('2025-07-12T19:30:00'), title: 'Saxon Grille in Scarsdale', image: Saxon07122025 },
    { date: new Date('2025-09-13T19:30:00'), title: 'South Shore Craft Brewery in Oceanside, Long Island', image: 'null' },
    { date: new Date('2025-10-24T19:30:00'), title: 'Redline Music Stage at K1 Speed in Mt Kisco', image: RedlineOct },
    { date: new Date('2026-01-09T19:00:00'), title: '89 North w/SCHISM A Tribute To TOOL', image: Schism_012026 },
    { date: new Date('2026-02-27T19:30:00'), title: 'Yonkers Brewing Co.', description: 'A full night of rock hits featuring Whats In The Box plus Say It Aint So, a high-energy tribute to Weezer.', image: SayItAintSoYO },
    { date: new Date('2026-06-05T19:30:00'), title: 'A Tribute To The Smashing Pumpkins FUNDRAISER', description: 'Enjoy an unforgettable night of live music featuring The Smashing Pumpkins Tribute Band, along with NY’s tribute to 90s alternative rock, What’s In The Box. The evening includes open bar, food, raffles, and more.', image: SmashingFundraiser },
    { date: new Date('2026-06-27T19:30:00'), title: 'Blue Point Brewery In Patchogue NY w/ No Doubt Tribute HELLA DOUBT ', description: 'A night full of rock-steady jams from No Doubt plus your Boys In The Box bringing the high-energy hits of 90s Alt Rock!', image: HellaDoubt062026 },
    { date: new Date('2026-08-28T19:30:00'), title: 'Collective Soul Afterparty at Garcias In Port Chester NY', description: 'We are taking over Garcias for the Collective Soul Afterparty!', image: GarciasIG },
    { date: new Date('2026-10-03T19:30:00'), title: 'Westchester Tattoo Convention', description: 'Westchester Tattoo Convention Main Stage at The Westchester County Center in White Plains, New York', image: WCCFlyer },
    { date: new Date('2026-10-04T19:30:00'), title: 'Westchester Tattoo Convention', description: 'Westchester Tattoo Convention Main Stage at The Westchester County Center in White Plains, New York', image: WCCFlyer },
  ];

  const setToMidnight = (date) => {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    return newDate;
  };

  const selectedDateMidnight = setToMidnight(value);
  const eventList = events.filter(event => setToMidnight(event.date).getTime() === selectedDateMidnight.getTime());

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const tileClassName = ({ date, view }) => {
    if (view === 'month') {
      const eventDate = events.find(event => setToMidnight(event.date).getTime() === setToMidnight(date).getTime());
      if (eventDate) {
        return 'event-date';
      }
    }
    return null;
  };

  useEffect(() => {
    const upcomingImagesContainer = document.getElementById('eventImages');
    const upcomingImages = upcomingImagesContainer.querySelectorAll('img');
  
    if (upcomingImages.length === 1) {
      upcomingImagesContainer.classList.add('single');
    } else {
      upcomingImagesContainer.classList.remove('single');
    }
  }, []);

  const pastEvents = [
    { href: "https://bloodandinkny.com/", img: WCCFlyer, alt: "Westchester County Tattoo Convention" },
    { href: "https://www.thecapitoltheatre.com/garcias-at-the-capitol-theatre/events/detail/whats-in-the-box", img: GarciasIG, alt: "Collective Soul Afterparty at Garcias" },
    { href: "https://secure.qgiv.com/for/pothawirainternational/event/slimfcac/", img: SmashingFundraiser, alt: "Smashing Pumpkins Tribute Fundraiser" },
    { href: "https://www.yonkersbrewing.com/event-details-registration/whats-in-the-box-say-it-aint-so-weezer-trbiute", img: SayItAintSoYO, alt: "Say It Aint So @ YO Brewing 02.2026" },
    { href: "https://tickets.tooltributeschism.com/event-details/1-9-26-tool-tribute-band-schism-25th-anniversary-show-with-whats-in-the-box-at-89-north-in-patchogue-ny", img: Schism_012026, alt: "Schism @ 89 North 01.2026" },
    { href: "https://www.instagram.com/redlinemusicstage/", img: RedlineOct, alt: "Redline October" },
    { href: "https://www.saxonwoodsgrill.com/", img: Saxon07122025, alt: "Saxon Grill July 12th" },
    { href: "https://www.yonkersbrewing.com/event-details-registration/blink-180who-a-blink-182-tribute", img: BlinkYonkers, alt: "Yonkers Brewing May 31st" },
    { href: "https://tickets.tooltributeschism.com/event-details/5-2-whats-in-the-box-with-tool-tribute-schism-at-89-north-in-patchogue-ny-w-almost-creed-pudding-time-primus", img: Schism_052025, alt: "Schism at 89 North" },
    { href: "https://www.yonkersbrewing.com/events", img: Eminescence, alt: "Eminescence at Yonkers Brewing Co" },
    { href: "https://www.instagram.com/p/DF5qu4KvedY/?hl=en", img: Stockroom02_2025, alt: "Stockroom Showcase" },
    { href: "https://bloodandinkny.com/pages/afterparty", img: WestchesterTattooCon, alt: "WestchesterTattooCon" },
    { href: "https://www.lucyspleasantvilleny.com/events", img: Lucys2024, alt: "Lucys_Nov2024" },
    { href: "https://www.gleasonspeekskill.com/events", img: GleasonsHalloween, alt: "GleasonsHalloween" },
    { href: "http://www.ramblinghousenyc.com/", img: RamblingJuly, alt: "RamblingJuly" },
    { href: "https://lacasamamaroneck.com/home", img: LaCasaJuly, alt: "LaCasaJuly" },
    { href: "https://www.gleasonspeekskill.com/events", img: GleasonsJune, alt: "GleasonsJune" },
    { href: "https://www.crazygames.com/game/duck-hunt", img: DuckJune, alt: "DuckInn" },
    { href: "https://www.joeyssportsbarandgrill.com/", img: Feb2PROMO, alt: "FebPromo" },
    { href: "https://www.joeyssportsbarandgrill.com/", img: JoeysJune, alt: "JoeysJune" },
    { href: "https://www.gleasonspeekskill.com/events", img: Gleasons, alt: "GleasonsMay" },
    { href: null, img: Hogs4Hope, alt: "Hogs4Hope" }, // no link
    { href: "http://www.ramblinghousenyc.com/", img: aprilPromo, alt: "AprilPromo" },
    { href: "https://www.crazygames.com/game/duck-hunt", img: DuckInnApril, alt: "DuckInn" },
];

const [pastModalOpen, setPastModalOpen] = useState(false);
const openPastModal = () => setPastModalOpen(true);
const closePastModal = () => setPastModalOpen(false);

const featuredPastEvents = pastEvents.slice(0, 4);
  

  return (
    <div id="events">
      <h2>Upcoming Events</h2>

      <Calendar class="calendar"
        onChange={onChange}
        value={value}
        onClickDay={(value) => {
          setValue(value);
          console.log('Clicked day:', value);
          openModal();
        }}
        tileClassName={tileClassName}
      />

      <Modal
        id="modal"
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Event List"
        className="custom-modal-content"
        overlayClassName="custom-modal-overlay"
      >
        <div className="modal-header">
          <button className="modal-close" onClick={closeModal} aria-label="Close modal">
            ✕
          </button>
          <h3 className="modal-title">Events on {value.toDateString()}</h3>
        </div>

        <ul className="event-list">
          {eventList.length > 0 ? (
            eventList.map((event, index) => (
              <li className="event-item" key={index}>
                <div className="event-flyer">
                  <img src={event.image} alt={event.title} />
                </div>

                <div className="event-info">
                  <h4 className="event-title">{event.title}</h4>

                  {/* Optional fields if you have them */}
                  {event.time && <p className="event-meta"><strong>Time:</strong> {event.time}</p>}
                  {event.location && <p className="event-meta"><strong>Location:</strong> {event.location}</p>}
                  {event.description && <p className="event-desc">{event.description}</p>}

                  {event.link && (
                    <a className="event-link" href={event.link} target="_blank" rel="noreferrer">
                      View details
                    </a>
                  )}
                </div>
              </li>
            ))
          ) : (
            <li className="no-events">No events for this date.</li>
          )}
        </ul>
      </Modal>


      <div id="eventImages" className="upcoming">

        {/* <a href="https://bloodandinkny.com/" target="_blank" rel="noopener noreferrer">
          <img id="start" src={WCCFlyer} alt='Westchester Tattoo Convention at The Westchester County Center in White Plains, New York' />
        </a> */}

        <img id="stayTuned" src={StayTuned} alt='Stay Tuned' />
        
      </div>
      <section className="past-events-section">
        <h2 id="pastEvents">Past Events</h2>

        <div className="past-events-header">

        </div>
        <div className="past-events-inner">
          <div className="past-events-grid">
            {featuredPastEvents.map((ev, i) =>
              ev.href ? (
                <a key={i} href={ev.href} target="_blank" rel="noopener noreferrer" className="flyer-card">
                  <img src={ev.img} alt={ev.alt} loading="lazy" decoding="async" />
                </a>
              ) : (
                <div key={i} className="flyer-card">
                  <img src={ev.img} alt={ev.alt} loading="lazy" decoding="async" />
                </div>
              )
            )}
          </div>
        </div>
      </section>

      <button className="past-events-cta" onClick={openPastModal}>
        See more
      </button>

      <Modal
        isOpen={pastModalOpen}
        onRequestClose={closePastModal}
        contentLabel="Past Events"
        className="past-modal-content"
        overlayClassName="custom-modal-overlay"
      >
        <div className="modal-header">
          <button className="modal-close" onClick={closePastModal} aria-label="Close past events modal">
            ✕
          </button>
          <h3 className="modal-title">Past Events</h3>
        </div>

        <div className="past-modal-scroll">
          <div className="past-modal-grid">
            {pastEvents.map((ev, i) =>
              ev.href ? (
                <a key={i} href={ev.href} target="_blank" rel="noopener noreferrer" className="flyer-card">
                  <img src={ev.img} alt={ev.alt} loading="lazy" decoding="async" />
                </a>
              ) : (
                <div key={i} className="flyer-card">
                  <img src={ev.img} alt={ev.alt} loading="lazy" decoding="async" />
                </div>
              )
            )}
          </div>
        </div>
      </Modal>


    </div>
  );
};

export default Events;